<template>
  <div class="editable-color" v-if="isEditing">
    <v-select
      class="select-box"
      v-model="selectedColor"
      :options="colorOptions"
      :getOptionLabel="()=>{}"
      placeholder="選択してください"
      :getOptionKey="(option) => option.id"
      :clearable="false"
      :filterable="false"
      :searchable="false"
    >
      <template #selected-option="{ id, color_hex, description }">
        <div class="color-option-selected">
          <color-chip
            :color="{id, color_hex}"
          >
          </color-chip>
          <span class="selected-description">{{description}}</span>
        </div>
      </template>
      <template #option="{ id, color_hex, description, sort_number, version }">
        <div class="color-option-list" @click="clickColorChip({id, color_hex, description, sort_number, version})">
          <color-chip
            :color="{id, color_hex, description, sort_number, version}"
          >
          </color-chip>
          {{description}}
        </div>
      </template>
    </v-select>
  </div>
  <div v-else class="editable-color">
    <color-chip :color="color"></color-chip>
    {{color ? color.description : null}}
  </div>
</template>

<script>

import ColorChip from "./ColorChip";
import vSelect from 'vue-select';
export default {
  components: {
    ColorChip,
    vSelect,
  },
  props: {
    color: { type: Object },
    colorOptions: { type: Array },
    isEditing: { type: Boolean },
  },
  data() {
    return {
      selectedColor: this.color
    }
  },
  watch: {
    isEditing() {
      this.selectedColor = this.color
    }
  },
  created() {
    if (this.color) this.clickColorChip(this.color)
  },
  methods: {
    clickColorChip(color) {
      this.selectedColor = color
      this.$emit("updateValue", color)
    }
  }
}
</script>

<style lang="scss">
.color-chip {
  margin: 0px 10px;
}
.editable-color {
  display: flex;
  .select-box {
    width: 100%;
    height: 37px;
  }
  .vs__dropdown-toggle {
    height: 100% !important;
    background: white;
  }
  .vs__dropdown-option {
    padding: 0px;
  }
  .vs__dropdown-menu {
    width: fit-content;
  }
  .vs__selected-options {
    align-items: center;
    width: 85%;
  }
  .vs__selected {
    margin-top: 5px;
    width: 100%;
  }
  .color-option-selected {
    display: flex;
    align-items: center;
    text-overflow: ellipsis;
    width: 100%;
  }
  .selected-description {
    flex-grow: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .color-option-list {
    display: flex;
    align-items: center;
    padding: 5px 10px 5px 5px;
  }
}
.editable-color-chip {
  cursor: pointer;
}
</style>
